export enum EParkingType {
  AllTypes = 0,
  Rooftop = 1,
  Underground = 2,
  Ground = 3,
  Multilevel = 4,
}
